const components_for_windows_and_curtain_walls = "Components for Windows and Curtain Walls";
const building_service_engineering = "Building Service Engineering";
const composites = "Composites";
const coverings = "Coverings";
const insulation_materials = "Insulation Materials";
const metals = "Metals";
const mineral_building_products = "Mineral Building Products";
const plastics = "Plastics";
const processes_at_building_site = "Processes at Building Site";
const wood = "Wood";
const end_of_life = "End of Life";
const energy_sources = "Energy sources";
const transport = "Transport";
const reagent = "Reagent";

export const envfactor_types = {
  components_for_windows_and_curtain_walls,
  building_service_engineering,
  composites,
  coverings,
  insulation_materials,
  metals,
  mineral_building_products,
  plastics,
  processes_at_building_site,
  wood,
  end_of_life,
  energy_sources,
  transport,
  reagent,
};
